import tmhRequest from '@/config/tmhRequest'

export default {

    searchStoreConsumeMemberStatusGradeReportColumn: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchstoreconsumememberstatusgradereportcolumn',
            method: 'post',
            data: data,
        })
    },

    searchStoreConsumeMemberStatusGradeReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchstoreconsumememberstatusgradereportcount',
            method: 'post',
            data: data,
        })
    },

    searchStoreConsumeMemberStatusGradeReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchstoreconsumememberstatusgradereportbypage',
            method: 'post',
            data: data,
        })
    },

     searchEmployeeConsumeMemberStatusGradeReportColumn: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchemployeeconsumememberstatusgradereportcolumn',
            method: 'post',
            data: data,
        })
    },

    searchEmployeeConsumeMemberStatusGradeReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchemployeeconsumememberstatusgradereportcount',
            method: 'post',
            data: data,
        })
    },

    searchEmployeeConsumeMemberStatusGradeReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchemployeeconsumememberstatusgradereportbypage',
            method: 'post',
            data: data,
        })
    },

    
     searchDetailConsumeMemberStatusGradeReportColumn: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchdetailconsumememberstatusgradereportcolumn',
            method: 'post',
            data: data,
        })
    },

    searchDetailConsumeMemberStatusGradeReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchdetailconsumememberstatusgradereportcount',
            method: 'post',
            data: data,
        })
    },

    searchDetailConsumeMemberStatusGradeReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchdetailconsumememberstatusgradereportbypage',
            method: 'post',
            data: data,
        })
    },



    searchListConsumeMemberStatusGradeReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/searchlistconsumememberstatusgradereport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportConsumeMemberStatusGradeReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusgradereport/exportconsumememberstatusgradereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusgradereport.js